/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./uploader-res-to-asset.vue?vue&type=template&id=6e587cfe&"
import script from "./uploader-res-to-asset.vue?vue&type=script&lang=js&"
export * from "./uploader-res-to-asset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports